<template>
  <table class="table">
    <tr v-for="(row, index) in dataValuesDP">
      <td><svg height="30" width="30">
          <rect height="30" width="30" v-bind:style="ColourBlockBackgroundStyle(index)" />
        </svg></td>
      <td>{{ chartLabels[index] }}</td>
      <td class="align-right"><strong>{{ row }}%</strong></td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    chartLabels: Array,
    dataValues: Array
  },
  methods: {
    ColourBlockBackgroundStyle(index) {
      const backgroundColors = ['#222051', '#554e72', '#8e859f', '#d9d6de', '#81236c', '#9c5f8b', '#bd98b2', '#e9dee6', '#0d6d80', '#458a9c', '#8eb1bd', '#636466', '#acaeb1', '#474749']
      return {
        'fill': backgroundColors[index]
      }
    }
  },
  computed: {
    dataValuesDP: function () {
      return this.dataValues.map(function (each_element) {
        return String(each_element.toFixed(1));
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.colour-block {
  display: block;
  height: 30px;
  width: 30px;
}

.align-right {
  text-align: right;
}</style>
